import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'

import {
  AUDIENCE_PREVIEWER_STICKY_TOP,
  AudiencePreviewer,
  AudiencePreviewerField,
} from '@entities/previewers'
import TagInfo, { TagInfoValues } from '@pages/tag/_shared/components/TagInfo'
import TagRule from '@pages/tag/_shared/components/TagRule'
import useGradingTag from '@pages/tag/_shared/hooks/useGradingTag'
import { formatNumber } from '@shared/lib/utils/number'
import SectionTitle from '@shared/ui/SectionTitle'

export const Grading = () => {
  const {
    handleTagCreate,
    handleTagPreview,
    handleTagRuleCopy,
    handleTagRuleCreate,
    handleTagRuleDelete,
    handleTagRuleRename,
    handleTagRuleUpdate,
    isCreatingTag,
    isFetchingPreview,
    previewData,
    selectTagRuleIndex,
    setSelectTagRuleIndex,
    setTagValues,
    tagValues,
    userCount,
  } = useGradingTag()

  const { t } = useTranslation(['tag', 'common', 'audience'])

  return (
    <>
      <SectionTitle title={t('tag:create_step_2_fill_tag_information')} />

      <Box sx={{ display: 'flex' }}>
        <Box sx={{ flexGrow: 1 }}>
          <TagInfo
            values={tagValues}
            onChange={tagInfo =>
              setTagValues(prev => ({
                ...prev,
                ...(tagInfo as TagInfoValues<'grading'>),
              }))
            }
          />

          <SectionTitle title={t('tag:create_step_3_select_tag_source_rule')} />

          <TagRule
            values={tagValues.tagRules ?? []}
            isFetching={false}
            selectTagRuleIndex={selectTagRuleIndex}
            onCopy={handleTagRuleCopy}
            onCreate={handleTagRuleCreate}
            onUpdate={handleTagRuleUpdate}
            onDelete={handleTagRuleDelete}
            onRename={handleTagRuleRename}
            onSelectTagRuleIndexChange={setSelectTagRuleIndex}
          />
        </Box>

        {/** sticky 需要 parent 可以滾動，因此將 marginLeft 另外寫 */}
        <Box sx={{ ml: 2 }}>
          <Box sx={{ position: 'sticky', top: AUDIENCE_PREVIEWER_STICKY_TOP }}>
            <AudiencePreviewer
              donutTitle={t('audience:of_users')}
              title={`${t('tag:total_tagged')}/${t('tag:total_people')}`}
              userCount={userCount}
              totalCount={previewData?.cdpUsersCount ?? 0}
              isLoading={isFetchingPreview}
              isCreating={isCreatingTag}
              onPreview={handleTagPreview}
              onCreate={handleTagCreate}
            >
              <AudiencePreviewerField>
                <p>{t('tag:total')}</p>
                <p>
                  {isFetchingPreview
                    ? '-'
                    : formatNumber(previewData?.cdpUsersCount ?? 0)}
                </p>
              </AudiencePreviewerField>

              {previewData?.valueInfos.map((item, idx) => {
                return (
                  <AudiencePreviewerField key={idx}>
                    <p>{item.value}</p>
                    <p>{formatNumber(item.count)}</p>
                  </AudiencePreviewerField>
                )
              })}
            </AudiencePreviewer>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default Grading
